import React from 'react';
import AgentUserTypeEntry from 'Users/components/UserAdministration/UserEntry/Agent/AgentUserTypeEntry';
import {matchUserTypeByLineOfBusiness, UserType} from 'Users/models/User/UserType';
import BeneficiariesUserTypeEntry from './Beneficiaries/BeneficiariesUserTypeEntry';
import BosToolsUserTypeEntry from './BosTools/BosToolsUserTypeEntry';
import EnrollTrackUserTypeEntry from './EnrollTrack/EnrollTrackUserTypeEntry';
import MessagingUserTypeEntry from './Messaging/MessagingUserTypeEntry';
import 'Core/components/Dashboard/Dashboard.sass';
import AppEntryUserTypeEntry from './AppEntry/AppEntryUserTypeEntry';

type UserTypeEntryProps = {
  userType: UserType;
  isEdit: boolean;
  isExternal: boolean;
  hasEnrollTrackAgentConnection: boolean;
  isUserSupport: boolean;
};

const UserTypeEntry = (props: UserTypeEntryProps) => {
  const {userType, isEdit, isExternal, hasEnrollTrackAgentConnection, isUserSupport} = props;

  return matchUserTypeByLineOfBusiness(userType.value, {
    Agent: agentUserType => (
      <AgentUserTypeEntry agentUserType={agentUserType} isEdit={isEdit} isExternal={isExternal} />
    ),
    EnrollmentTracking: enrollTrackUserType => (
      <EnrollTrackUserTypeEntry
        enrollTrackUserType={enrollTrackUserType}
        isEdit={isEdit}
        isExternal={isExternal}
        hasEnrollTrackAgentConnection={hasEnrollTrackAgentConnection}
        isUserSupport={isUserSupport}
      />
    ),
    BosTools: bosToolsUserType => <BosToolsUserTypeEntry bosToolsUserType={bosToolsUserType} isEdit={isEdit} />,
    Beneficiaries: beneficiariesUserType => (
      <BeneficiariesUserTypeEntry beneficiariesUserType={beneficiariesUserType} isEdit={isEdit} />
    ),
    Messaging: messagingUserType => <MessagingUserTypeEntry messagingUserType={messagingUserType} isEdit={isEdit} />,
    AppEntry: appEntryUserType => <AppEntryUserTypeEntry appEntryUserType={appEntryUserType} isEdit={isEdit} />,
  });
};

export default UserTypeEntry;
